
import TokenManagerService from '../../../services/TokenManagerService';

class customerService {

    /**
     * Refreshes the session by calling TAS /refresh via TokenManagerService.
     * The new access token is stored in memory (never localStorage).
     *
     * @returns {Promise<{ status: string, refreshToken: string }>}
     */
    refreshToken() {
        return TokenManagerService.refreshAccessToken()
            .then((accessToken) => {
                return { status: 'Success', refreshToken: accessToken };
            }).catch(err => {
                return err;
            });
    }
}


export default customerService;
